import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-jobsettings',
  templateUrl: './jobsettings.component.html',
  styleUrls: ['./jobsettings.component.css']
})
export class JobsettingsComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;


  constructor() { }

  ngOnInit(): void {
  }

  requestData = `
  curl 'https://api.optimusdrive.ai/v1/customer/update' \ -X 'PUT' \ -H 'authorization: XXX' \ --data-raw 
'{ 
  "image": { 
    "upscaler_process_settings": { 
      "type": "4x", 
      "ask_me_every_time": false 
    }, 
    "upscaler_file_management_properties": { 
      "file_copy_preference": "manual_copy", 
      "ask_me_every_time": false 
    }, 
    "optimizer_process_settings": { 
      "type": "quality", 
      "ask_me_every_time": false 
    }, 
    "optimizer_file_management_properties": { 
      "file_copy_preference": "manual_copy", 
      "ask_me_every_time": false 
    }, 
    "enhancer_process_settings": { 
      "type": "4x", 
      "ask_me_every_time": false 
    }, 
    "enhancer_file_management_properties": { 
      "file_copy_preference": "manual_copy", 
      "ask_me_every_time": false 
    } 
  }, 
  "vod": { 
    "upscaler_process_settings": { 
      "type": "default", 
      "ask_me_every_time": false 
    },
    "optimizer_process_settings": { 
      "type": "size", 
      "ask_me_every_time": false 
    }, 
    "upscaler_file_management_properties": { 
      "file_copy_preference": "manual_copy", 
      "ask_me_every_time": false 
    }, 
    "optimizer_file_management_properties": { 
      "file_copy_preference": "manual_copy", 
      "ask_me_every_time": false 
    } 
  }, 
  "email_notification_settings": { 
    "notify_when_file_processed": true, 
    "notify_when_limit_reached": true 
  }
}'  

`

  responseData = `
  {
    "data": {
      "id": "528878d5-b8ca-4a16-9520-8b559d61eb16",
      "user_type": "",
      "name": "Abhijit",
      "family_name": “TEST”,
      "email": "abhijittest@yopmail.com",
      "company_name": "",
      "credits": 222.08166666666676,
      "updated_at": 1694438175,
      "vod": {
        "media_preset_id": "8f2c93f6-6603-4ad8-a774-5fbe63428a6f",
        "media_preset_name": "default",
        "transcoder_preset_id": "a9ceebde-1ac0-4505-9f9c-ebfdeaa3910a",
        "transcoder_preset_name": "default",
        "input_bucket": "cmw-dev-som-media",
        "output_bucket": "cmw-dev-som-media",
        "region": "us-east-1",
        "managed_by": "crunch",
        "is_configured": "true",
        "primary_use": "Both",
        "primary_storages": null,
        "upscaler_file_management_properties": {
          "ask_me_every_time": false,
          "file_copy_preference": "manual_copy"
        },
        "optimizer_file_management_properties": {
          "ask_me_every_time": false,
          "file_copy_preference": "manual_copy"
        },
        "upscaler_process_settings": {
          "type": "default",
          "ask_me_every_time": false
        },
        "optimizer_process_settings": {
          "type": "size",
          "ask_me_every_time": false
        }
      },
      "image": {
        "upscaler_file_management_properties": {
          "ask_me_every_time": false,
          "file_copy_preference": "manual_copy"
        },
        "upscaler_process_settings": {
          "type": "4x",
          "ask_me_every_time": false
        },
        "optimizer_file_management_properties": {
          "ask_me_every_time": false,
          "file_copy_preference": "manual_copy"
        },
        "optimizer_process_settings": {
          "type": "quality",
          "ask_me_every_time": false
        },
        "enhancer_file_management_properties": {
          "ask_me_every_time": false,
          "file_copy_preference": "manual_copy"
        },
        "enhancer_process_settings": {
          "type": "4x",
          "ask_me_every_time": false
        }
      },
      "email_notification_settings": {
        "notify_when_file_processed": true,
        "notify_when_limit_reached": true,
        "account_related_notification": true
      },
      "storage_connection_details": {
        "dropbox": false,
        "googledrive": false,
        "oci": false,
        "s3": true
      }
    },
    "message": "User updated successfully"
  }
  `



  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
        this.copyButton = false;
        this.copiedButton = true;
        // After a few seconds, reset the button states
        setTimeout(() => {
          this.copyButton = true;
          this.copiedButton = false;
        }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }





}
